<template>
    <div ref="trigger" class="scroll-top-container" :class="containerClasses">
        <div class="scroll-top-inner" v-bind:style="{'top': threshold + 'px'}"><slot></slot></div>
    </div>
</template>

<script>
    export default {
        props: {
            threshold: {
                type: Number|String,
                default: 0,
            },
        },
        data() {
            return {
                windowTop: 0,
                windowBottom:0,
                elementTop: 0,
                original: 0,
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handle);
            this.elementTop = this.$refs.trigger.getBoundingClientRect().top;

            let initialTop = this.$refs.trigger.getBoundingClientRect().top;
            this.original = initialTop;
        },
        methods: {
            handle() {
                if (this.triggered) {
                    if (window.scrollY <= (this.original - parseInt(this.threshold))) {
                        this.windowTop = window.scrollY;
                        this.elementTop = this.$refs.trigger.getBoundingClientRect().top;
                    }
                } else {
                    this.windowTop = window.scrollY;
                    this.elementTop = this.$refs.trigger.getBoundingClientRect().top;
                }
            }
        },
        computed: {
            offset() {
                return this.elementTop;
            },
            triggered() {
                return this.offset <= this.threshold;
            },
            containerClasses() {
                return {
                    'stuck': this.triggered,
                }
            },
            styling() {
                return {
                    'width': this.threshold
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .scroll-top-container {
        &.stuck {
            > div {
                position:fixed;
                width:auto!important;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/ScrollTop.vue